var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6876 13.7425L10.1765 1.73982C9.80937 1.06287 9.1826 0.658691 8.49999 0.658691C7.81732 0.658691 7.19055 1.06287 6.82349 1.73982L0.312361 13.7424C-0.0784453 14.4629 -0.104371 15.3762 0.24492 16.126C0.594212 16.8755 1.26249 17.3411 1.98897 17.3411H15.0111C15.7375 17.3411 16.4058 16.8756 16.7552 16.1258C17.1043 15.3762 17.0784 14.463 16.6876 13.7425ZM8.49999 15.3208C7.90123 15.3208 7.4159 14.7497 7.4159 14.0454C7.4159 13.3409 7.90128 12.7699 8.49999 12.7699C9.09875 12.7699 9.58407 13.3409 9.58407 14.0454C9.58407 14.7497 9.0987 15.3208 8.49999 15.3208ZM10.0026 6.45794L9.46866 10.6874C9.39006 11.31 8.89736 11.7397 8.36822 11.6472C7.94072 11.5725 7.6202 11.1782 7.55429 10.7018L6.97445 6.48072C6.83946 5.49792 7.40721 4.57245 8.24259 4.41364C9.07797 4.25483 9.86461 4.92277 9.9996 5.90557C10.025 6.09063 10.0241 6.28168 10.0026 6.45794Z",
    fill: "#DE4242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningRed);
export default __webpack_public_path__ + "static/media/icon-warning-red.8cbc9abbfe1d2eba637559d0a1d47b66.svg";
export { ForwardRef as ReactComponent };